import type { FeedComment } from "../types/feed.ts"

const KEYS = ["response", "data", "comments", "items", "result"] as const

export function unwrapCommentListPayload(body: unknown): FeedComment[] {
  if (body == null) return []
  if (Array.isArray(body)) return body as FeedComment[]
  if (typeof body !== "object") return []
  const o = body as Record<string, unknown>
  const candidates: FeedComment[][] = []
  for (const k of KEYS) {
    const v = o[k]
    if (!Array.isArray(v)) continue
    const list = v as FeedComment[]
    if (list.length > 0) return list
    candidates.push(list)
  }
  return candidates[0] ?? []
}
